import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'

export const useLoadPickups = () => {
  const defaultPropertiesContext = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultPropertiesContext?.agentConfiguration?.handlerKey)
  const loadPickups = async (sessionId: number, availabilityId: string | undefined) => {
    const response = await fetch(`${baseUrl}/api/pickups?sessionId=${sessionId}&availabilityId=${availabilityId}`, {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
      },
    })

    return await response.json()
  }
  return loadPickups
}
